import React from "react";
import classNames from "classnames";
import moment from "moment";
import styles from "./OpportunityDetails.module.scss";
import { Icon } from "../../atoms/Icon";
import { Button, Menu, MenuItem, Popover } from "@blueprintjs/core";
const stringRenderer = ({ className, cellData }) => (
  <div className={className}>{cellData}</div>
);

const nameRenderer = ({ className, cellData, rowData }) => {
  return (
    <div className={classNames(className, styles.cellWrapper)}>
      <div className={styles.imageWrapper}>
        <img
          alt="profile"
          width={33}
          height={33}
          src={rowData.picture}
          className={styles.thumbnail}
        />
      </div>
      <div className={styles.accountNameText}>{cellData}</div>
    </div>
  );
};

const dateRenderer = ({ className, cellData, rowData }) => (
  <div className={className}>
    {moment(new Date(cellData)).format("MMM, DD YYYY")}
  </div>
);

const videosCreatedRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Icon className={styles.tableIcon} name="Camera-Broadcast" />
    {cellData}
  </div>
);

const earningsRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Icon className={styles.tableIcon} name="Cash" />
    {cellData}
  </div>
);

const videosViewsRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Icon className={styles.tableIcon} name="Eye-Public" />
    {cellData}
  </div>
);

const chatRenderer = ({ className, cellData, rowData }, isReadOnly) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Button
      onClick={(e) => {
        rowData.initChat(cellData);
        e.stopPropagation();
      }}
      minimal
      icon={<Icon name="chat" />}
      disabled={isReadOnly}
    />
  </div>
);

const menuRenderer = ({ className, cellData, rowData }, isReadOnly) => (
  <div
    className={classNames(className, styles.cellWrapper)}
    onClick={(e) => e.stopPropagation()}
  >
    <Popover>
      <Button
        minimal
        icon={<Icon name="Menu-Horizontal" />}
        disabled={isReadOnly}
      />
      {!isReadOnly && (
        <Menu>
          {rowData.type === "applicant" ? (
            <>
              <MenuItem
                icon={<Icon name="Approve" />}
                text="Approve Applicant"
                onClick={rowData.approveApplicant}
              />
              <MenuItem
                icon={<Icon name="Decline" />}
                text="Decline Applicant"
                onClick={rowData.declineApplicant}
              />
            </>
          ) : (
            <>
              <MenuItem
                className={styles.removeInfluencer}
                text="Remove Influencer"
                onClick={rowData.removeInfluencer}
              />
            </>
          )}
        </Menu>
      )}
    </Popover>
  </div>
);

const renderers = {
  string: stringRenderer,
  appliedDate: dateRenderer,
  videosCreated: videosCreatedRenderer,
  videosViews: videosViewsRenderer,
  earnings: earningsRenderer,
  name: nameRenderer,
  chat: chatRenderer,
  id: menuRenderer
};

const Cell = (isReadOnly) => (cellProps) => {
  const format = cellProps.column.key || "string";
  const renderer = renderers[format] || renderers.string;

  return renderer(cellProps, isReadOnly);
};

const components = (isReadOnly) => ({
  TableCell: Cell(isReadOnly)
});

export default components;
